import React, { useEffect, useState } from 'react';
import { Col, Row, Alert, Button, Form, Modal } from "react-bootstrap";
import { Dispatch, bindActionCreators, AnyAction } from 'redux';
import { connect } from 'react-redux';
import { historyActionCreators } from '../../store/HistoryStore';
import { AppState } from '../../store/configureStore';
import Skeleton from "react-loading-skeleton";
import { schedulePaymentActionCreators } from '../../store/SchedulePaymentStore';
import { PaymentAccountDropDwon, PaymentAccountDrowDownProps } from '.././PaymentAccountDropDown';
import DatePicker from 'react-datepicker';
import { CheckWrapper } from '.././CheckWrapper';
import { driverPay_source, driverHoliday } from '../../DCR.dtos';
import { getAccountFieldValueByName } from '../../functions/dcrGlobal';
import ContributionSummary from '.././ContributionSummary';
import { helperActionCreators, Permissions } from '../../store/HelperStore';
import { accountActionCreators } from '../../store/AccountStore';
import { hasPermission } from '../../functions/hasPermission';

type TContributionSchedulePaymentProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;
const ContributionSchedulePayment = (props: TContributionSchedulePaymentProps) => {

    const allowSchedulePayment = hasPermission(Permissions.ContributionDetails_Schedule, props.currentUserPermissions);

    const [currentTime, setCurrentTime] = useState("");
    const [checked, setChecked] = useState(false);
    const [isSubmitClick, setIsSubmitClick] = useState(false);
    const [totalContribution, setTotalContribution] = useState("");
    const [disableSubmitBtn, setDisableSubmitBtn] = useState(!allowSchedulePayment);
    const [sendPaymentDate, setSendPaymentDate] = useState<Date | null>(null);
    const [acctType, setAcctType] = useState("");
    const [seqNum, setSeqNum] = useState("");
    const [isPageLoaded, setIsPageLoaded] = useState(false);
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [dDate, setDDate] = useState<string | null>(null);
    const [isShowAlertBox, setIsShowAlertBox] = useState(false);
    const [alertTitle, setAlertTitle] = useState("");
    const [alertMessage, setAlertMessage] = useState("");
    const [isErrorOrWarning, setIsErrorOrWarning] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [isRedirectOnOkClick, setIsRedirectOnOkClick] = useState(true);

    useEffect(() => {
        setIsPageLoaded(props.cmSchedulePayment.isHolidayListLoaded && props.cmSchedulePayment.isGetCurrentTimeLoaded)
    }, [props.cmSchedulePayment.isHolidayListLoaded, props.cmSchedulePayment.isGetCurrentTimeLoaded]);

    useEffect(() => {
        props.fetchCMGetCurrentTime()
        props.fetchCMHolidayList(true)
        const total = props.cmSchedulePayment.cmContribs.find(x => x.name === "Total Contributions:")?.value;
        setTotalContribution(total ? total : "")
    }, []);

    const getFilterValue = (val: string) => {
        return val.replace("$", "").replace(",", "");
    }
    const isAHoliday = (dateToCheck: Date | null) => {
        const dateToCheckNew: driverHoliday = new driverHoliday();
        dateToCheckNew.date = dateToCheck ? dateToCheck?.toString() : "";

        if (dateToCheck && props.cmSchedulePayment.isHolidayListLoaded
            && props.cmSchedulePayment?.cmHolidayListInfo?.holidays?.length > 0
            && props.cmSchedulePayment?.cmHolidayListInfo?.holidays.indexOf(dateToCheckNew) >= 0) {
            return true;
        }
        return false;
    };
    const checkForHolidaysAndWeekend = (dateToCheck: Date) => {
        let daysToAdd = 0
        let daysToAddForHolidays = 0;
        const dayOfWeek = dateToCheck?.getDay();
        if (dayOfWeek === 6) //If it is a Saturday then set the date of Monday
            daysToAdd = 2;
        if (dayOfWeek === 7)//If it is a Sunday then set the date of Monday
            daysToAdd = 1;
        let newDateToCheck = new Date(dateToCheck);
        newDateToCheck.setDate(newDateToCheck.getDate() + daysToAdd);
        while (isAHoliday(newDateToCheck)) {
            daysToAddForHolidays = daysToAddForHolidays + 1;
            newDateToCheck = new Date(newDateToCheck ? newDateToCheck?.getDate() + daysToAddForHolidays : "");
        }
        return newDateToCheck;
    };

  
   
    useEffect(() => {

        if (parseFloat(getFilterValue(totalContribution)) === 0 || props.cmSchedulePayment.cmContribs.length < 3) {
            setErrorMessage("Total contributions must be greater than zero to schedule payment.");
            setIsErrorOrWarning(true);
            setDisableSubmitBtn(true);
        }

        else {
            setErrorMessage("");
            setIsErrorOrWarning(false);
            if (allowSchedulePayment) {
                setDisableSubmitBtn(false);
            }
        }

    }, [totalContribution]);

    useEffect(() => {
        if (props.cmSchedulePayment?.isGetCurrentTimeLoaded) {
            setCurrentTime(props.cmSchedulePayment?.cmGetCurrentTimeInfo?.currentDateTime)
        }
        if (props.cmSchedulePayment?.isGetCurrentTimeError) {
            setErrorMessage("Error occured while getting current time from system.")
            setIsErrorOrWarning(true)
        }
    }, [props.cmSchedulePayment?.isGetCurrentTimeLoaded]);

    const checkCurrentServerTime = () => {
        const hour = new Date(currentTime).getHours();
        if (hour >= 15) {
            return 1;
        }
        else {
            return 0;
        }
    };
    const disableHoliday = (dateToCheck: Date) => {
        if (props.cmSchedulePayment?.cmHolidayListInfo?.holidays.find(x => new Date(x.date).getTime() === new Date(dateToCheck).getTime())) {
            return true;
        }
        else {
            return false;
        }
    }

    const setDefaultDate = () => {
        const dayToAdd = checkCurrentServerTime();
        const todayOrNextDay = new Date(currentTime ? currentTime : props.cmSchedulePayment?.cmGetCurrentTimeInfo?.currentDateTime);
        todayOrNextDay.setDate(todayOrNextDay.getDate() + dayToAdd);
        const nextBusinessDate = checkForHolidaysAndWeekend(todayOrNextDay);
        setStartDate(nextBusinessDate)
    };

    function GetFormattedDate(newDate: Date | null) {
        if (newDate) {
            const todayTime = newDate;
            const month = (todayTime?.getMonth() + 1);
            const day = (todayTime?.getDate());
            const year = (todayTime?.getFullYear());
            return (((month < 10) ? ("0" + month) : (month)) + "/" + ((day < 10) ? ("0" + day) : (day)) + "/" + year);
        }
        return "";
    }

    const deliveredByDate = () => {
        if (sendPaymentDate && acctType) {
            const daysToAdd = acctType?.toLowerCase() === "wespath" ? 0 : 2;
            let deliByDate = new Date(sendPaymentDate);
            for (let i = 0; i < daysToAdd; i++) {
                deliByDate.setDate(deliByDate.getDate() + 1);
                deliByDate = disableHoliday(deliByDate) ? new Date(deliByDate.setDate(deliByDate.getDate() + 1)) : deliByDate;
                deliByDate = checkForHolidaysAndWeekend(deliByDate);
            }
            setDDate(GetFormattedDate(deliByDate))
            return GetFormattedDate(deliByDate);
        }
        else {
            setDDate("")
            return "";
        }
    }


    useEffect(() => {
        if (props.cmSchedulePayment?.isHolidayListLoaded && props.cmSchedulePayment?.isGetCurrentTimeLoaded) {
            setDefaultDate();
        }
    }, [props.cmSchedulePayment?.isHolidayListLoaded, props.cmSchedulePayment?.isGetCurrentTimeLoaded]);

    useEffect(() => {
        if (props.cmSchedulePayment.cmContribs.length !== 0 && parseInt(getFilterValue(totalContribution)) !== 0
            && parseInt(seqNum) !== 0 && checked && seqNum && allowSchedulePayment) {
            setDisableSubmitBtn(false)
        }
        else {
            setDisableSubmitBtn(true)
        }
    }, [props.cmSchedulePayment.cmContribs, seqNum, checked, totalContribution]);

    useEffect(() => {
        setSendPaymentDate(startDate ? startDate : null)
        deliveredByDate();
    }, [startDate]);


    useEffect(() => {
        if (props.cmSchedulePayment.isWespathInfoLoaded
            && props.cmSchedulePayment?.cmWespathInfo !== null
            && props.cmSchedulePayment?.cmWespathInfo?.sufficientfunds
            && props.cmSchedulePayment?.cmWespathInfo?.sufficientfunds?.message
        ) {
            setAlertMessage(props.cmSchedulePayment?.cmWespathInfo?.sufficientfunds?.message)
            setAlertTitle("Warning")
            setIsShowAlertBox(true)
            setIsRedirectOnOkClick(false)
        }
    }, [props.cmSchedulePayment.isWespathInfoLoaded]);

    useEffect(() => {
        if (props.cmSchedulePayment.isPaymentLoaded
            && props.cmSchedulePayment !== null
            && props.cmSchedulePayment?.cmPaymentUpdateInfo
            && props.cmSchedulePayment?.cmPaymentUpdateInfo?.paymentinfo?.message
        ) {
            if (props.cmSchedulePayment?.cmPaymentUpdateInfo.paymentinfo?.status
                && props.cmSchedulePayment?.cmPaymentUpdateInfo?.paymentinfo?.status?.toLowerCase() === "received"
                && props.cmSchedulePayment?.isPaymentLoaded
            ) {
                setIsShowAlertBox(true)
                setAlertMessage(props.cmSchedulePayment?.cmPaymentUpdateInfo?.paymentinfo?.message)
                setAlertTitle('Contribution Management')
            }
            else if (props.cmSchedulePayment?.cmPaymentUpdateInfo?.paymentinfo?.message) {
                setErrorMessage(props.cmSchedulePayment?.cmPaymentUpdateInfo?.paymentinfo?.message)
                setIsErrorOrWarning(true)
                setIsShowAlertBox(false)
            }
        }
        if (props.cmSchedulePayment.isPaymentUpdateError) {
            setIsShowAlertBox(false)
            setIsErrorOrWarning(true)
            setErrorMessage("Error occured while performing schedule payment. Reason : " + props.cmSchedulePayment.paymentUpdateErrorMsg)
        }
    }, [props.cmSchedulePayment.isPaymentLoaded, props.cmSchedulePayment.isPaymentUpdateError]);


   
    useEffect(() => {
        deliveredByDate();
    }, [startDate, seqNum, acctType]);

      const handleAccountDropDwonChnage = (selectedAccount: driverPay_source) => {
        if (selectedAccount !== undefined) {
            if (selectedAccount.acct_type.toLowerCase() === 'wespath') {
                props.fetchCMWespath(getAccountFieldValueByName(selectedAccount, "Wespath Account Number:"), getFilterValue(totalContribution))
            }
            setAcctType(selectedAccount.acct_type)
            setSeqNum(selectedAccount?.sequence.toString())
        }
        else {
            setAcctType("")
            setSeqNum("")
        }
    }

    function generateXML() {
        const listLength = props.cmSchedulePayment.cmContribs.length;
        const rawXml = "<SchedulePayment  cca_id='#cca_id#' payment_date='#pmtDate#' forfeiture_amount='#amt_forfeiture#' final_funding_amount='#amt_finalfunding#' account_sequence='#acc_sequence#'/>";
        const cca_id = props.cmSchedulePayment.ccaId;
        const payment_date = GetFormattedDate(sendPaymentDate);
        const amt_forfeiture = getFilterValue(props.cmSchedulePayment.cmContribs[(listLength - 2)].value)?.replace("(", "").replace(")", "");
        const amt_finalfunding = getFilterValue(props.cmSchedulePayment.cmContribs[(listLength - 1)].value);
        const xmlData = rawXml.replace("#cca_id#", cca_id)
            .replace("#pmtDate#", payment_date)
            .replace("#amt_forfeiture#", amt_forfeiture)
            .replace("#amt_finalfunding#", amt_finalfunding)
            .replace("#acc_sequence#", seqNum.padStart(3, "0"));
        return xmlData;
    }

    
    const onDateChange = (date: Date) => {
        setStartDate(date);
        setSendPaymentDate(date)
    }

    const successSchedulePayment = () => {
        setIsShowAlertBox(false);
        setErrorMessage("");
        setIsErrorOrWarning(false);
        setIsShowAlertBox(false);
        setAlertMessage("");
        setAlertTitle("");
        props.fetchCMHistory(props.selectedUmcId, false, false);
        props.resetAllStateAndRedirectToHistory();
    }

    const submitClick = () => {
        setIsSubmitClick(true);
        if (!disableSubmitBtn && checked) {
            setErrorMessage("")
            setIsErrorOrWarning(false)
            setIsShowAlertBox(false)
            props.fetchCMPaymentUpdate(generateXML(), dDate ?? "")
            setIsShowAlertBox(false)
        }
    }

    const cancelClick = () => {
        props.resetAllStateAndRedirectToDetails();
    }

    return (
        <>
            <Row style={{ padding: "1.2%" }}>
                <Col>
                    <Row className="tbl-info-wrap">
                        <Col className="">
                            <h4 className="float-left">Schedule Payment of Contributions</h4>
                        </Col>
                    </Row>
                    {isErrorOrWarning &&
                        <Alert className="mt-2" variant="danger">
                            <Row>
                                <Col>
                                    {errorMessage}
                                </Col>
                            </Row>
                        </Alert>
                    }
                    {props.cmSchedulePayment.isWespathInfoError &&
                        <Alert className="mt-2" variant="danger">
                            <Row>
                                <Col>
                                    Error occured while getting Wespath BankInfo.
                                </Col>
                            </Row>
                        </Alert>
                    }
                    {(!isPageLoaded) && <LoadingSkeleton />}
                    {isPageLoaded &&
                        <>
                            <Row className="px-3">
                                <Col className="col-12 col-md-5 mb-2">
                                    <div>
                                        <Row>
                                            <Col className="my-2">
                                                <h6> Contribution Summary for {props.cmSchedulePayment.statusDate} </h6>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className="pl-4">
                                                <ContributionSummary />
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                                <Col className="col-12 col-md-7">
                                    <Row className="mt-3 mt-sm-0">
                                        <Col className="my-2 ">
                                            <h6>Payment Account</h6>
                                        </Col>
                                    </Row>
                                    <PaymentAccountDropDwon className="col-12 col-md-9" onChange={(selectedAccount: driverPay_source) => { handleAccountDropDwonChnage(selectedAccount) }} />
                                </Col>
                            </Row>
                            <hr />
                            <Row className="px-3">
                                <Col className="col-12">
                                {"Select a payment date to begin the funding process for this payroll period's contributions. The deliver by date is the date your employees' accounts will be credited."}
                                </Col>
                                <Col className="col-12">
                                {'Payments must be cancelled before 3:00 p.m., Central on the "Send Payment On" date.'}
                                </Col>
                            </Row>
                            <Form.Group>
                                <Row className="mt-2 px-3">
                                    <Col className="col-12 col-md-6 col-lg-5 col-xl-3 mb-2">
                                        <Row>
                                            <Col className="col-12 col-md-6 col-lg-5 col-xl-6 pr-md-0">
                                                <Form.Label className="control-label">Send Payment On:</Form.Label>
                                            </Col>
                                            <Col className="col-12 col-md-6 col-lg-5 col-xl-6 pl-md-0">
                                                <span className="ml-xl-3 control-value">
                                                    <DatePicker
                                                        className="form-control"
                                                        selected={startDate}
                                                        onChange={(changeDate: Date) => onDateChange(changeDate)}
                                                        dateFormat='MM/dd/yyyy'
                                                        minDate={new Date(currentTime)}
                                                        showYearDropdown
                                                        filterDate={(date) => (date.getDay() !== 6 && date.getDay() !== 0 && !disableHoliday(date))}
                                                    />
                                                </span>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col className="col-12 col-md-5 col-lg-3 ml-xl-3">
                                        <Row>
                                            <Col className="col-12 col-md-6 col-lg-6 col-xl-5 pr-md-0">
                                                <Form.Label className="control-label">Delivered By:</Form.Label>
                                            </Col>
                                            <Col className="col-12 col-md-6 col-lg-6 col-xl-6 pl-md-0 ">
                                                <span className="control-value">
                                                    {dDate}
                                                </span>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Form.Group>
                            <Row className="mt-4">
                                <CheckWrapper>
                                    <Form.Check className={"ml-4 control-value"} custom onChange={(e: React.ChangeEvent<HTMLInputElement>) => { setChecked(e.target.checked) }} checked={checked} id="chk_agree" type="checkbox" value="Y" label="The details above are correct, and I would like to begin the payroll process." />
                                </CheckWrapper>
                            </Row>
                            {!checked && isSubmitClick &&
                                <Alert className="mt-2" variant="danger">
                                    <Row>
                                        <Col>
                                            Please confirm that the details above are correct and you intend to schedule the payment by checking the box above.
                                        </Col>
                                    </Row>
                                </Alert>
                            }
                            <hr />
                            {props.cmSchedulePayment.isPaymentLoding && <LoadingSkeletonForButtons />}
                            {!props.cmSchedulePayment.isPaymentLoding &&
                                <Row>
                                    <Col>
                                        <div className="mt-1 pt-3 mb-5">
                                            <Button className="btn-block-xs-only float-right btn btn-primary" variant="primary" disabled={disableSubmitBtn}
                                                onClick={() => {
                                                    submitClick();
                                                }}>Submit</Button>
                                            <Button onClick={() => { cancelClick(); }} className="btn-block-xs-only float-right mr-sm-3 btn btn-secondary"
                                                variant="secondary">Cancel</Button>
                                        </div>
                                    </Col>
                                </Row>
                            }
                        </>
                    }

                    <Modal show={isShowAlertBox} backdrop="static" centered >
                        <Modal.Header>
                            <Modal.Title>{alertTitle}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="text-justify">
                            <Row>
                                <Col className="mx-2">
                                    {alertMessage}
                                </Col>
                            </Row>
                        </Modal.Body>
                        <div className="border-top mt-4 p-3">
                            <>
                                <Button className="btn-block-xs-only float-right" variant="primary"
                                    onClick={() => { isRedirectOnOkClick ? successSchedulePayment() : setIsShowAlertBox(false) }}>Ok
                                </Button>
                            </>
                        </div>
                    </Modal>
                </Col>
            </Row>
        </>
    )
}
const LoadingSkeletonForButtons = () => (
    <div className="row">
        <Col className="col-12 col-sm-2 col-md-4 col-lg-8 d-none d-sm-block"></Col>
        <Col className="col-12 col-sm-5 col-md-4 col-lg-2">
            <div className="mt-2"><Skeleton width={'100%'} /></div>
        </Col>
        <Col className="col-12 col-sm-5 col-md-4 col-lg-2">
            <div className="mt-2"><Skeleton width={'100%'} /></div>
        </Col>
    </div>
);

const LoadingSkeleton = () => (
    <div className="row container">
        <div className="col-12 pl-2">
            <div className="mt-2"><Skeleton width={'100%'} /></div>
            <div><Skeleton width={'95%'} /></div>
            <div className="mt-2"><Skeleton width={'100%'} /></div>
            <div><Skeleton width={'95%'} /></div>
            <div className="mt-2"><Skeleton width={'100%'} /></div>
            <div><Skeleton width={'95%'} /></div>
            <div className="mt-2"><Skeleton width={'100%'} /></div>
            <div><Skeleton width={'95%'} /></div>
            <div className="mt-2"><Skeleton width={'100%'} /></div>
            <div><Skeleton width={'95%'} /></div>
            <div className="mt-2"><Skeleton width={'100%'} /></div>
            <div><Skeleton width={'95%'} /></div>
            <div className="mt-2"><Skeleton width={'100%'} /></div>
            <div><Skeleton width={'95%'} /></div>
        </div>
    </div>
);


function mapStateToProps(state: AppState, paymentAccountDrowDownProps: PaymentAccountDrowDownProps) {
    return {
        cmSchedulePayment: state.cmSchedulePayment,
        selectedUmcId: state.dcr.selectedInstitution,
        accounts: state.accounts,
        currentUserPermissions: state.dcr.currentuserInfo?.user?.permissions,
        ownProps: paymentAccountDrowDownProps
    }
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators(
        {
            ...schedulePaymentActionCreators,
            ...historyActionCreators,
            ...accountActionCreators,
            ...helperActionCreators,
            resetHistory: historyActionCreators.resetState
        }, dispatch);
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ContributionSchedulePayment);